import * as React from 'react'
import {
  makeStyles,
  createStyles,
  Theme,
} from 'cs-kevlar-react/lib/es/theming/theme'
import { Typography } from 'cs-kevlar-react'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tokenCreationStepsList: {
      padding: 0,
      paddingLeft: theme.spacing(8),
      margin: 0,
      marginTop: theme.spacing(8),
      marginBottom: theme.spacing(8),
    },
  }),
)

interface TokenCreationExplanationProps {
  bulletPoints: string[]
}

export const TokenCreationExplanation: React.FunctionComponent<TokenCreationExplanationProps> = (
  props,
) => {
  const classes = useStyles({})
  return (
    <ul className={classes.tokenCreationStepsList}>
      {props.bulletPoints.map((bulletPoint, idx) => (
        <li key={`ExplanationBulletPoints::${idx}`}>
          <Typography
            variant="body1"
            dangerouslySetInnerHTML={{ __html: bulletPoint }}
          />
        </li>
      ))}
    </ul>
  )
}
